<div class="page-layout-container">
  <div class="row">
    <h1 class="title">Invoices Monthly Report</h1>
  </div>
  <div *ngIf="!invoiceReport?.length" class="alert alert-warning">
    <p>To change invoice status , dates.. update in Invoice details page</p>
  </div>
  <div *ngIf="message" class="alert alert-warning">{{ messageDesc }}</div>
  <div class="row">
    <div class="col-md-auto">
      <mat-form-field>
        <mat-label>Select Month for generating invoices Report</mat-label>
        <input
          matInput
          [matDatepicker]="leaveEndDate"
          required
          (dateChange)="fetchInvoiceReport($event)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="leaveEndDate"
        ></mat-datepicker-toggle>
        <mat-datepicker #leaveEndDate></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col" *ngIf="invoiceReport?.length">
      <button mat-button (click)="downloadInvoiceReport()">
        Download Invoice Report
      </button>
    </div>
  </div>

  <div>
    <mat-form-field appearance="standard">
      <mat-label>Filter</mat-label>
      <input
        matInput
        (keyup)="applyFilter($event)"
        placeholder="search with Employee Name"
        #input
      />
    </mat-form-field>

    <table
      mat-table
      [dataSource]="invoiceDataSource"
      matSort
      (matSortChange)="announceSortChange($event)"
      class="mat-elevation-z8"
    >
      <ng-container matColumnDef="invoiceId">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Invoice id"
        >
          Invoice ID
        </th>
        <td mat-cell *matCellDef="let element">{{ element.invoiceId }}</td>
      </ng-container>

      <ng-container matColumnDef="iniFlowInvoiceId">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Peppol id"
        >
          Peppol Invoice ID
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.iniFlowInvoiceId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="employeeId">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Employee id"
        >
          Employee Name
        </th>
        <td mat-cell *matCellDef="let element">{{ element.employeeId }}</td>
      </ng-container>

      <ng-container matColumnDef="nishContractId">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by contract id"
        >
          NISH ContractID
        </th>
        <td mat-cell *matCellDef="let element">{{ element.nishContractId }}</td>
      </ng-container>

      <ng-container matColumnDef="clientName">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by clientName"
        >
          Client Name
        </th>
        <td mat-cell *matCellDef="let element">{{ element.clientName }}</td>
      </ng-container>
      <ng-container matColumnDef="vendorName">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by vendorName"
        >
          Vendor Name
        </th>
        <td mat-cell *matCellDef="let element">{{ element.vendorName }}</td>
      </ng-container>
      <ng-container matColumnDef="invoiceType">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by invoiceType"
        >
          Invoice Type
        </th>
        <td mat-cell *matCellDef="let element">{{ element.invoiceType }}</td>
      </ng-container>
      <ng-container matColumnDef="month">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Month"
        >
          Generated for Month
        </th>
        <td mat-cell *matCellDef="let element">{{ element.month }}</td>
      </ng-container>
      <ng-container matColumnDef="year">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by year"
        >
          Generated for Year
        </th>
        <td mat-cell *matCellDef="let element">{{ element.year }}</td>
      </ng-container>
      <ng-container matColumnDef="generatedBy">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by user"
        >
          Generated User
        </th>
        <td mat-cell *matCellDef="let element">{{ element.generatedBy }}</td>
      </ng-container>
      <ng-container matColumnDef="daysOrHours">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by daysOrHours"
        >
          Days/Hours
        </th>
        <td mat-cell *matCellDef="let element">{{ element.daysOrHours }}</td>
      </ng-container>
      <ng-container matColumnDef="rate">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by rate "
        >
          Rate
        </th>
        <td mat-cell *matCellDef="let element">{{ element.rate }}</td>
      </ng-container>
      <ng-container matColumnDef="amt">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by amt"
        >
          Amount
        </th>
        <td mat-cell *matCellDef="let element">{{ element.amt }}</td>
      </ng-container>
      <ng-container matColumnDef="vat">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by vat"
        >
          VAT
        </th>
        <td mat-cell *matCellDef="let element">{{ element.vat }}</td>
      </ng-container>

      <ng-container matColumnDef="total">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by total"
        >
          Total
        </th>
        <td mat-cell *matCellDef="let element">{{ element.total }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by status"
        >
          Status
        </th>
        <td mat-cell *matCellDef="let element">{{ element.status }}</td>
      </ng-container>
      <ng-container matColumnDef="tsFlag">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by tsFlag"
        >
          TS Required Flag
        </th>
        <td mat-cell *matCellDef="let element">{{ element.tsFlag }}</td>
      </ng-container>
      <ng-container matColumnDef="generatedDate">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Timesheet uploaded flag"
        >
          Generated Date
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.generatedDate | date : "dd/MMMM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="submittedDate">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by submittedDate"
        >
          Submitted Date
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.submittedDate | date : "dd/MMMM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="dueDate">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by dueDate"
        >
          Bill Due Date
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.dueDate | date : "dd/MMMM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="billReceivedDate">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by billReceivedDate"
        >
          Bill ReceivedDate
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.billReceivedDate | date : "dd/MMMM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="billRejectedDate">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by billRejectedDate"
        >
          Rejected Date
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.billRejectedDate | date : "dd/MMMM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="billOnHoldDate">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by billOnHoldDate"
        >
          Bill OnHold Date
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.billOnHoldDate | date : "dd/MMMM/yyyy" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="comments">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by comments"
        >
          Comments
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.comments }}
        </td>
      </ng-container>

      <ng-container matColumnDef="accComments">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by accComments"
        >
          Account Comments
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.accComments }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
    ></mat-paginator>
  </div>

  <app-progress [loading$]="loading$"> </app-progress>
</div>
